// extracted by mini-css-extract-plugin
export default {"nav-drop-down":"NavBar_nav-drop-down__ptLLH","nav-settings":"NavBar_nav-settings__4yZhU"};